import * as React from "react";
import {Box, Button, Container, Grid, Link} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {HeaderLogo} from "./HeaderLogo";
import {HeaderGradientLine} from "./HeaderGradientLine";
import {Menu} from "react-feather";
import {useTheme} from "@mui/material/styles";

/**
 * La nav commune aux pages
 * @constructor
 */
export function MainNav({onClick, isMobile}: {onClick: () => void, isMobile: boolean}) {
    const theme = useTheme();


    return (
        <Box position={"fixed"} width={"100%"} zIndex={10} bgcolor={"background.default"}>
            <HeaderGradientLine/>
            <Box
                sx={(theme) => ({
                    backgroundColor: "background.paper",
                    borderBottom: `1px solid ${theme.palette.divider}`
                })}
            >
                <Container maxWidth={"lg"}>
                    <Grid container>
                        <Grid item xs={3} alignSelf={"center"}>
                            {isMobile ? (
                                <Button
                                    disableRipple={true}
                                    variant={"text"}
                                    onClick={onClick}
                                    sx={{
                                        border: 0,
                                        padding: 0,
                                        minWidth: "auto",
                                        "&:hover": {
                                            background: "none",
                                        }
                                    }}
                                >
                                    <Menu color={theme.palette.text.primary}/>
                                </Button>
                            ) : (
                                <Link href={"https://2fd37bfd.sibforms.com/serve/MUIEAIiP0wJsOWNuIuT-KqLwbiImgT4Ae2QskAPvqXXkrIYy0WuNGQGOZNr9r3tkMHjxqL9tPf-RApAAH98PuY7cm4MqnKP35tA4_vG_FJJS0fPW25uZksy1_k11qJwNq6BPoMxmEmLy7FWQLN5GR4b54-uow0nt2kBFxgvmbx5a9DH-Rbd2gGP7-982ztqoEFQNZp2XdSjhBVO2"} target={"_blank"} rel={"noreferrer noopener"} underline={"none"} component={"a"}>
                                    <Button variant={"contained"} color={"secondary"}>Newsletter</Button>
                                </Link>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            <Link
                                component={RouterLink} to={"/"}
                                py={2}
                                display={"flex"}
                                justifyContent={"center"}
                                aria-label={"Logo de Datagora media"}
                            >
                                <HeaderLogo/>
                            </Link>
                        </Grid>
                        <Grid item xs={0} md={3} alignSelf={"center"} sx={{display: {xs: "none", md: "flex"}, justifyContent: "flex-end"}}>
                            <Link component={RouterLink} to={"/contact"} underline={"none"}>
                                <Button variant={"contained"} color={"primary"}>Contact & partenariat</Button>
                            </Link>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
}
